import { getData, postData } from '~/utils/service';
import type { VaultNewRecordsResponse, VaultSeenRecords } from './types';

export const VAULT_NEW_RECORDS_ROUTES = {
  get: '/providers/{provider_id}/vault-new-records',
  post: '/providers/{provider_id}/vault-new-records/seen',
};

export const getVaultNewRecords = (providerId: number) =>
  getData<VaultNewRecordsResponse>('vaultNewRecords', {
    pathParams: { provider_id: String(providerId) },
  });

/** Reports exactly these records as seen; any other mark (a parse that landed since) stays new. */
export const markVaultRecordsSeen = (providerId: number, records: VaultSeenRecords) =>
  postData<void>('vaultNewRecords', {
    pathParams: { provider_id: String(providerId) },
    data: { records },
  });
